import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
    name: 'devicesSelected',
    initialState: {devicesSelected: [],},
    reducers: {
        updateDevicesSelected(state, action) {
            state.devicesSelected = action.payload;
        },
    }
});

export { actions as devicesSelectedActions };
export { reducer as devicesSelectedReducer };
